import ClearingAPI from '@shared/api';

export const {
    clientDetails: { getUnassignedClient: getUnassignedClient, deleteUser: deleteUser },
} = ClearingAPI.settings;
